module.exports = {
    ...require('./networkConfig.context'),
    ...require('./socket.context')
}
